import { 
	NOTIFICATION, 
	RESET_HEADER,
	SET_REPEAT_TOUR_ACTION
} from './types';

export function resetHeader() {
  return {
    type: RESET_HEADER
  };
}

/* Actions Creators */
export function notification(obj) {
  return {
    type: NOTIFICATION,
    payload: obj
  };
}

export function setRepeatTourAction(action) {
  return {
    type: SET_REPEAT_TOUR_ACTION,
    payload: {
      action: action
    }
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/header/index.js